// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2710":"0319a4b5398392025378","4471":"9b3c8620f038b7593241","7004":"da5a822695a273d4d2eb","7394":"9b9a710e7fcefb63fcb4","7859":"449c6cbdb74832a2f6c7","8127":"8825f856581210b8af66","8453":"d4f76450bf0c442af291"}[chunkId] + "";
};